import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useServerApi } from "../../hooks/userServerApi";
import QuizStatCards from "./QuizStatCards";

const QuizPageStats = forwardRef(({ mb = 35 }, ref) => {
  const [api] = useServerApi();
  const [stats, setStats] = useState({});

  const load = async () => {
    const res = await api.Quiz.getListStatistics();
    setStats(res?.data ?? {});
  };

  useImperativeHandle(ref, () => ({ refresh: load }));

  useEffect(() => {
    load();
  }, []);

  return (
    <div style={{ marginBottom: mb }}>
      <QuizStatCards stats={stats} />
    </div>
  );
});

QuizPageStats.displayName = "QuizPageStats";

export default QuizPageStats;
